import React, { cloneElement, memo } from 'react';
import { string, bool, func, node, oneOfType } from 'prop-types';
// import { useTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import classNames from 'classnames';

import Clickable from 'common/Clickable';
import { PortalBody } from 'common/Portals';

import Close from 'images/close.svg';
// import CheckIcon from 'images/icons/check.svg';

import useStyles from './useStyles';

import './Modal.scss';

const Modal = ({
  modalClassName = '',
  className,
  contentClassName = '',
  close,
  children,
  open = false,
  subtitle,
  title,
  noPortal,
  headerClassName = '',
  noHeader = false,
  headerAdditionalContent = undefined,
}) => {
  // const { t } = useTranslation();
  const styles = useStyles();

  if (open && !noPortal) document.body.style.overflow = 'hidden';
  if (!open) document.body.style.overflow = '';

  const container = classNames('modal_container', styles.modalContainer, className);

  const clickHandler = (e) => {
    e.stopPropagation();
  };

  const modal = (
    <div className={`modal ${modalClassName}`}>
      <div cursor={false} className={container}>
        <Clickable
          type="div"
          cursor={false}
          className={`modal_content ${contentClassName}`}
          onClick={clickHandler}
        >
          <div className="modal__wrapper">
            {!noHeader && (
              <header className={headerClassName}>
                <div className="modal__headline">
                  <h4 className="headline__title">{title}</h4>
                  {subtitle && <h4 className="headline__subtitle">{subtitle}</h4>}
                </div>
                {headerAdditionalContent && (
                  <div className="headline__additionalContent">
                    {typeof headerAdditionalContent === 'function'
                      ? headerAdditionalContent()
                      : headerAdditionalContent}
                  </div>
                )}
                <IconButton onClick={close} size="small" className="header__icon">
                  <Close />
                </IconButton>
              </header>
            )}
            <section className="modal__section">
              {typeof children === 'function'
                ? children({ close })
                : cloneElement(children, { handleCloseModal: close })}
            </section>
          </div>
        </Clickable>
      </div>
    </div>
  );
  return open && (noPortal ? modal : <PortalBody>{modal}</PortalBody>);
};

Modal.propTypes = {
  className: string,
  sectionClassName: string,
  close: func.isRequired,
  children: oneOfType([node, func]).isRequired,
  open: bool,
  subtitle: string,
  title: string.isRequired,
};

export default memo(Modal);
